module.exports = __webpack_public_path__ + "static/media/gaizao-lianyungangzhongyiyuan.96a5fb89.png";